import React, { useState } from "react";
import "./qualification.css";

const Qualification = () => {
  const [toggleState, setToggleState] = useState(2);

  const toggleTab = (index) => {
    setToggleState(index);
  };
  return (
    <section className="qualification section" id="qualification">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My personal journey</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? "qualification__button qualification__active button-flex"
                : "qualification__button button-flex"
            }
            onClick={() => toggleTab(1)}
          >
            <i className="uil uil-graduation-cap qualification__icon"></i>{" "}
            Education
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__button qualification__active button-flex"
                : "qualification__button button-flex"
            }
            onClick={() => toggleTab(2)}
          >
            <i className="uil uil-briefcase-alt qualification__icon"></i>{" "}
            Experience
          </div>

          <div
            className={
              toggleState === 3
                ? "qualification__button qualification__active button-flex"
                : "qualification__button button-flex"
            }
            onClick={() => toggleTab(3)}
          >
            <i class="uil uil-award qualification__icon"></i>{" "}
            Certifications
          </div>

        </div>
      </div>

      <div className="qualification__sections">
        {/* 1 */}
        <div
          className={
            toggleState === 1
              ? "qualification__content qualification__content-active "
              : "qualification__content"
          }
        >
          <div className="qualification__data">
            <div>
              <h3 className="qualification__title">Diploma</h3>
              <span className="qualification__subtitle">National Org. for <br/>Exceptional Talents<br/> (Sampad) - Iran</span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> 2014 - 2019</i>
              </div>
            </div>
            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>

          </div>

          <div className="qualification__data">
            <div></div>
            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>
            <div>
              <h3 className="qualification__title">Bachelor’s in<br /> Computer Engineering</h3>
              <span className="qualification__subtitle">Politecnico di Torino - Italy</span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> 2021 - 2025</i>
              </div>
            </div>
          </div>

          <div className="qualification__data">
            <div>
              <h3 className="qualification__title">Master’s in<br /> Cybersecurity</h3>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> 2026 - Ongoing</i>
              </div>
            </div>
            <div>
              <span className="qualification__rounder"></span>
            </div>
          </div>

        </div>
        {/* 2 */}
        <div
          className={
            toggleState === 2
              ? "qualification__content qualification__content-active "
              : "qualification__content"
          }
        >
          
          <div className="qualification__data">
            <div>
              <h3 className="qualification__title">Volunteer Instructor</h3>
              <span className="qualification__subtitle">Mesbah Inst. - Iran</span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> Sep 2015 - Sep 2018</i>
              </div>
            </div>
            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>
          </div>

          <div className="qualification__data">
            <div></div>
            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>
            <div>
            <h3 className="qualification__title">Web Developer</h3>
              <span className="qualification__subtitle">Actionz - Italy</span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> Jan 2023 - Jul 2023</i>
              </div>
            </div>
          </div>

          <div className="qualification__data">
            <div>
            <h3 className="qualification__title">Security Analyst</h3>
              <span className="qualification__subtitle">Freelance</span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> Jul 2023 - Oct 2023</i>
              </div>
            </div>

            

            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>
          </div>

          <div className="qualification__data">
            <div></div>
            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>
            <div>
            <h3 className="qualification__title">Hands-On Projects & <br />Career Exploration</h3>
              <span className="qualification__subtitle"></span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> 2024</i>
              </div>
            </div>
          </div>
          <div className="qualification__data">
            <div>
              <h3 className="qualification__title">CyberChallenge.IT Training Program &amp;<br /> TeamItaly Competition</h3>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> Feb 2025 - September 2025</i>
              </div>
            </div>
            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>
          </div>

          <div className="qualification__data">
            <div></div>
            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>
            <div>
              <h3 className="qualification__title">SOC Analyst</h3>
              <span className="qualification__subtitle">NAIS</span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> Jun 2025 - Nov 2025</i>
              </div>
            </div>
          </div>

          <div className="qualification__data">
            <div>
              <h3 className="qualification__title">Penetration Tester</h3>
              <span className="qualification__subtitle">NAIS</span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> Oct 2025 - May 2026</i>
              </div>
            </div>
            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>
          </div>

          <div className="qualification__data">
            <div></div>
            <div>
              <span className="qualification__rounder"></span>
            </div>
            <div>
              <h3 className="qualification__title">Security Engineer</h3>
              <span className="qualification__subtitle">Bizclap</span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> May 2026 - Present</i>
              </div>
            </div>
          </div>

        </div>
        {/* 3 */}
        <div
          className={
            toggleState === 3
              ? "qualification__content qualification__content-active "
              : "qualification__content"
          }
        >
          <div className="qualification__data">
            <div>
              <h3 className="qualification__title">Web Dev Bootcamp</h3>
              <span className="qualification__subtitle">Udemy</span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> Dec 2023</i>
              </div>
            </div>

            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>
          </div>

          <div className="qualification__data">
            <div></div>
            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>
            <div>
              <h3 className="qualification__title">Postman API</h3>
              <span className="qualification__subtitle">Postman</span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> Jan 2024</i>
              </div>
            </div>
          </div>

          <div className="qualification__data">
            <div>
              <h3 className="qualification__title">OWASP TOP 10</h3>
              <span className="qualification__subtitle">Voorivex Academy</span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt">Dec 2024</i>
              </div>
            </div>
            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>
          </div>
        

        <div className="qualification__data">
            <div></div>
            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>
            <div>
              <h3 className="qualification__title">Security+</h3>
              <span className="qualification__subtitle">Udemy</span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> Jan 2025</i>
              </div>
            </div>
          </div>

          <div className="qualification__data">
            <div>
              <h3 className="qualification__title">Learning Something Great <i class="bi bi-emoji-laughing"></i></h3>
              <span className="qualification__subtitle"></span>
              <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"> Ongoing ...</i>
              </div>
            </div>
            <div>
              <span className="qualification__rounder"></span>
              <span className="qualification__line"></span>
            </div>
          </div>



          </div>
      </div>
    </section>
  );
};

export default Qualification;
